import { render, staticRenderFns } from "./CampaignDetailsReport.vue?vue&type=template&id=56d54c21&scoped=true"
import script from "./CampaignDetailsReport.vue?vue&type=script&lang=js"
export * from "./CampaignDetailsReport.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetailsReport.vue?vue&type=style&index=0&id=56d54c21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d54c21",
  null
  
)

export default component.exports